module.exports = "<sui-table [tableModel]='getTableModel()'> </sui-table>";


//////////////////
// WEBPACK FOOTER
// ./src/app/samples/sample.table/sample.table.component.html
// module id = 416
// module chunks = 0